import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-trafficLight",
	templateUrl: "./trafficLight.component.html",
	styleUrl: "./trafficLight.component.scss",
})
export class trafficLightComponent implements OnInit {
	@Input() pourcentage: number;
	constructor() {}

	ngOnInit() {}
	isValidNumber(value: any): boolean {
		return !isNaN(value);
	}
}
